import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { gql } from '../../node_modules/graphql-tag/lib/index.js';

var _templateObject;
var refreshInstallationAddressQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query Installations($giid: String!) {\n    installation(giid: $giid) {\n      installationAddress {\n        phone\n        phone2\n        firstName\n        lastName\n        city\n        street\n        postalNumber\n        streetNumber\n        longitude\n        latitude\n      }\n    }\n  }\n"])));

export { refreshInstallationAddressQuery };
